import type { FieldValue, Timestamp } from 'firebase/firestore';

export interface BaseFirestoreEntity {
  createdAt: FieldValue | Timestamp;
  updatedAt: FieldValue | Timestamp;
}

export interface BaseAppEntity {
  id: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export const OnboardingProgress = {
  EnteredReferralCode: 'entered_referral_code',
  RespondedToWhatBringsYouHere: 'responded_to_what_brings_you_here',
  DrawnHeart: 'drawn_heart',
  AnsweredOcdThemeQuestions: 'answered_ocd_theme_questions',
  GaveNotificationPermissions: 'gave_notification_permissions',
  GaveRating: 'gave_rating',
  FinishedOnboarding: 'finished_onboarding',
} as const;

export type OnboardingProgress = (typeof OnboardingProgress)[keyof typeof OnboardingProgress];

interface QuestJourney {
  createdAt: Date;
  currentDay: number;
  isCurrentDayCompleted: boolean;
  journeyDayCompletedAt?: Date;
  journeyDayStartedAt: Date;
  updatedAt: Date;
}

export interface SttUsage {
  sessionsThisWeek: number;
  weeklyResetTimestamp: Date;
}

export interface VoiceUsage {
  conversationsThisWeek: number;
  minutesThisWeek: number;
  weeklyResetTimestamp: Date;
}

/**
 * Last-seen time and device facts. The app sends them through the API's `syncDeviceInfo`;
 * users who have not opened that app version yet have a one-time RevenueCat backfill.
 */
export interface DeviceInfo {
  lastSeenAt?: Date;
  source?: 'app' | 'revenuecat';
  platform?: string;
  appVersion?: string;
  appBuild?: string;
  osVersion?: string;
  manufacturer?: string;
  model?: string;
  isVirtual?: boolean;
  webViewVersion?: string;
  /** BCP 47 device language tag, e.g. `en-GB`. */
  locale?: string;
  notificationPermission?: string;
  /** ISO 3166-1 alpha-2, from the IP address. RevenueCat backfill only. */
  country?: string;
}

export interface ObsessLessUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  createdAt: Date;
  hasFinishedOnboarding: boolean;
  onboardingProgress: string;
  referralCode?: string;
  questJourney?: QuestJourney;
  sttUsage?: SttUsage;
  voiceUsage?: VoiceUsage;
  /** Device IANA timezone, saved by the app on start. */
  timezone?: string;
  deviceInfo?: DeviceInfo;
}
